import React, { useCallback } from 'react';
import {
  Outlet,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import { useRedirect } from 'react-admin';
import { Grid } from '@mui/material';

import SubNavigation from '../../../layout/SubNavigation';
import { StyledTab, StyledTabs } from '../../../layout/Tab';
import PopulationRegister from './PopulationRegister';
import BusinessAssociation from './BusinessAssociation';
import Pep from './pep';
import SanctionList from './sanction';
import CriminalRecord from './CriminalRecord';
import AdverseMedia from './adverseMedia';
import useCurrentTab from '../../../../hooks/useCurrentTab';
import IpScreenings from '../../../entities/IpScreenings';

const KycDataTabs = () => {
  const redirect = useRedirect();

  const handleKycTabChange = useCallback((
    _event: React.SyntheticEvent<Element, Event>,
    newValue: string,
  ) => {
    redirect(`../${newValue}`);
  }, [redirect]);

  const activeTab = useCurrentTab();

  return (
    <Routes>
      <Route
        path="*"
        element={(
          <Grid container spacing={4}>
            <Grid size={12}>
              <SubNavigation>
                <StyledTabs value={activeTab === '' ? 'spar' : activeTab} onChange={handleKycTabChange}>
                  <StyledTab label="Population register" value="spar" />
                  <StyledTab label="Business association" value="business-association" />
                  <StyledTab label="PEP" value="pep" />
                  <StyledTab label="Sanction list" value="sanction-list" />
                  <StyledTab label="Criminal record" value="criminal-record" />
                  <StyledTab label="Adverse media" value="adverse-media" />
                  <StyledTab label="IP screenings" value="ip-screenings" />
                </StyledTabs>
              </SubNavigation>
            </Grid>
            <Grid size={12}>
              <Outlet />
            </Grid>
          </Grid>
        )}
      >
        <Route index element={<Navigate to="spar" replace />} />
        <Route path="spar">
          <Route path="*" element={<PopulationRegister />} />
        </Route>
        <Route path="business-association">
          <Route path="*" element={<BusinessAssociation />} />
        </Route>
        <Route path="pep">
          <Route path="*" element={<Pep />} />
        </Route>
        <Route path="sanction-list">
          <Route path="*" element={<SanctionList />} />
        </Route>
        <Route path="criminal-record">
          <Route path="*" element={<CriminalRecord />} />
        </Route>
        <Route path="adverse-media">
          <Route path="*" element={<AdverseMedia />} />
        </Route>
        <Route path="ip-screenings">
          <Route path="*" element={<IpScreenings />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default KycDataTabs;
